import { lazy } from 'react';
import { CRoutes } from 'src/routes';

/** import pages */
const PlusSubscriptionStartGuidePage = lazy(() => import('src/pages/StartGuide/plusSubscription'));
const StartGuidePersonalPage = lazy(() => import('src/pages/StartGuide/personal'));
const StartGuideCSRPage = lazy(() => import('src/pages/StartGuide/csr'));
const StartGuideAdvocatePage = lazy(() => import('src/pages/StartGuide/adv'));
const StartGuideOrganizationPage = lazy(() => import('src/pages/StartGuide/org'));

/** define routes */
export const ROUTE_START_GUIDE_ORGANIZATION = '/org';
export const ROUTE_START_GUIDE_ADVOCATE = '/adv';
export const ROUTE_START_GUIDE_CSR = '/csr';
export const ROUTE_START_GUIDE_PERSONAL = '/personal';
export const ROUTE_START_GUIDE_EVERGREEN = '/evergreen/onboarding';
export const ROUTE_START_GUIDE_PLUS_SUBSCRIPTION = '/plus/onboarding';

/** export routes */
export const startGuideRoutes: CRoutes = [
  {
    path: ROUTE_START_GUIDE_ORGANIZATION,
    Component: StartGuideOrganizationPage,
    exact: true,
  },
  {
    path: ROUTE_START_GUIDE_ADVOCATE,
    Component: StartGuideAdvocatePage,
    exact: true,
  },
  {
    path: ROUTE_START_GUIDE_CSR,
    Component: StartGuideCSRPage,
    exact: true,
  },
  {
    path: ROUTE_START_GUIDE_PERSONAL,
    Component: StartGuidePersonalPage,
    exact: true,
  },
  {
    path: ROUTE_START_GUIDE_EVERGREEN,
    Component: PlusSubscriptionStartGuidePage,
    exact: true,
  },
  {
    path: ROUTE_START_GUIDE_PLUS_SUBSCRIPTION,
    Component: PlusSubscriptionStartGuidePage,
    exact: true,
  },
];
